// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  transition: 0.2s ease-in-out;
}
.accordion .accordion-item-container {
  padding: 32px 32px 16px 32px;
  border-radius: 24px;
  background-color: #F9F9F9;
  margin-bottom: 16px;
}
.accordion .accordion-title {
  padding: 0;
  padding-bottom: 16px;
  background-color: #F9F9F9;
  width: 100%;
  text-align: left;
  border: none;
  outline: none;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  color: #2A2A2A;
}
.accordion .accordion-content {
  overflow: hidden;
  transition: height 0.3s ease-out;
  color: #949494;
  line-height: 24px;
  width: 688px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .accordion .accordion-item-container .accordion-item .accordion-content {
    width: 100%;
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .accordion .accordion-item-container .accordion-item .accordion-content {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Accordion/accordion.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,WAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;AADJ;AAGI;EACI,4BAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AADR;AAKI;EACI,UAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAHR;AAMI;EACI,gBAAA;EACA,gCAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;AAJR;;AC/BY;ED2CA;IACI,WAAA;EARd;AACF;AC9BY;EDoCA;IACI,WAAA;EAHd;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.accordion {\n    width: 100%;\n    max-width: 800px;\n    margin: 0 auto;\n    transition: .2s ease-in-out;\n\n    .accordion-item-container {\n        padding: 32px 32px 16px 32px;\n        border-radius: 24px;\n        background-color: #F9F9F9;\n        margin-bottom: 16px;\n\n    }\n\n    .accordion-title {\n        padding: 0;\n        padding-bottom: 16px;\n        background-color: #F9F9F9;\n        width: 100%;\n        text-align: left;\n        border: none;\n        outline: none;\n        cursor: pointer;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        font-size: 16px;\n        font-weight: 700;\n        color: #2A2A2A;\n    }\n\n    .accordion-content {\n        overflow: hidden;\n        transition: height 0.3s ease-out;\n        color: #949494;\n        line-height: 24px;\n        width: 688px;\n    }\n}\n\n@include media(mobile, tablet) {\n    .accordion {\n        .accordion-item-container {\n           .accordion-item {\n            .accordion-content {\n                width: 100%;\n            }\n           }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
